import ShutterbugShare from './ShutterbugShare';

export default ShutterbugShare;
